import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import thietLapNoiBo from "services/hrm/thietLapNoiBoService";

export const createThemeSinhNhat = createAsyncThunk(
    "thietLapNoiBo/createThemeSinhNhat",
    async (data, { rejectWithValue }) => {
        try {
            const { onSuccess } = data;
            const response = await thietLapNoiBo.createThemeSinhNhat(data);
            if (onSuccess) onSuccess(response.data);
            return response.data?.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const updateThemeSinhNhat = createAsyncThunk(
    "thietLapNoiBo/updateThemeSinhNhat",
    async (data, { rejectWithValue }) => {
        try {
            const { onSuccess } = data;
            const response = await thietLapNoiBo.updateThemeSnhNhat(data);
            if (onSuccess) onSuccess(response.data);
            return response.data?.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const deleteThemeSinhNhat = createAsyncThunk(
    "thietLapNoiBo/deleteThemeSinhNhat",
    async (data, { rejectWithValue }) => {
        try {
            const { onSuccess, id } = data;
            const response = await thietLapNoiBo.deleteThemeSinhNhat(id);
            if (onSuccess) onSuccess(response.data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const getThemeSinhNhat = createAsyncThunk(
    "thietLapNoiBo/getThemeSinhNhat",
    async (_, { rejectWithValue }) => {
        try {
            const response = await thietLapNoiBo.getThemeSinhNhat();
            return response.data?.data || response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

const initialState = {
    loading: false,
    themeSinhNhatList: [],
};

const thietLapNoiBoSlice = createSlice({
    name: "thietLapNoiBo",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(createThemeSinhNhat.pending, (state) => { state.loading = true; })
            .addCase(createThemeSinhNhat.fulfilled, (state) => { state.loading = false; })
            .addCase(createThemeSinhNhat.rejected, (state) => { state.loading = false; })

            .addCase(updateThemeSinhNhat.pending, (state) => { state.loading = true; })
            .addCase(updateThemeSinhNhat.fulfilled, (state) => { state.loading = false; })
            .addCase(updateThemeSinhNhat.rejected, (state) => { state.loading = false; })

            .addCase(deleteThemeSinhNhat.pending, (state) => { state.loading = true; })
            .addCase(deleteThemeSinhNhat.fulfilled, (state) => { state.loading = false; })
            .addCase(deleteThemeSinhNhat.rejected, (state) => { state.loading = false; })

            .addCase(getThemeSinhNhat.pending, (state) => { state.loading = true; })
            .addCase(getThemeSinhNhat.fulfilled, (state, action) => {
                state.loading = false;
                state.themeSinhNhatList = action.payload || [];
            })
            .addCase(getThemeSinhNhat.rejected, (state) => { state.loading = false; });
    },
});

export default thietLapNoiBoSlice.reducer;
